import React from "react";
import { Box } from "@mui/material";
import Navbar from "@/components/home/Navbar";
import PerformanceIndicatorManager from "@/components/indicators/PerformanceIndicatorManager";

const PerformanceIndicatorPage: React.FC = () => {
  return (
    <Box>
      <Navbar />
      <Box sx={{ p: 3 }}>
        <PerformanceIndicatorManager />
      </Box>
    </Box>
  );
};

export default PerformanceIndicatorPage;
